const moulageToInterventions = require('../config/moulageToInterventions');

module.exports = function isApplicableMoulage(interventions, moulages) {
  for (const intervention of interventions) {
    if (intervention.allMoulages) {
      return true;
    }
  }
  for (const [location, moulage] of Object.entries(moulages)) {
    const interventionMap = moulageToInterventions[moulage];
    if (interventionMap) {
      for (const intervention of interventions) {
        const interventionInfo = interventionMap[intervention.key];
        if (interventionInfo &&
            interventionInfo.triggeringLocations &&
            interventionInfo.triggeringLocations.includes(location)) {
          return true;
        }
      }
    }
  }
  return false;
}

/*
Notes on moulageToInterventions:
> This file is generated by a migration script:
  cases-service\src\migrations\5883-parse-moulage-interventions.js
> The command to run (from the root of cases service):
  node src\migrations\5883-parse-moulage-interventions.js input-file.tsv
> Input-file.tsv is an export from the following spreadsheet:
  https://docs.google.com/spreadsheets/d/1tE8XFwCPmuZoC3wIvzxiHO0O8anUvkqbPXbYRzBc8S4/edit#gid=440757245
> The export is done by selecting File | Download | Tab Separated Values (*.tsv)
> As of 2023-05-17, there is an additional manual step of editing moulageToIntervention:
  > Go to [FRACTURE_CLOSED_LOWER][PADDED_BOARD_SPLINT_FULL_LEG].triggeringLocations, and remove the entries with ARM and HAND
  > Go to [FRACTURE_CLOSED_LOWER][PADDED_BOARD_SPLINT_FULL_ARM].triggeringLocations, and remove the entries with LEG and FOOT
  > Go to [FRACTURE_CLOSED_LOWER][PADDED_BOARD_SPLINT_WRAP_SHORT].triggeringLocations, and remove the entries with LEG and FOOT
  > Go to [FRACTURE_CLOSED_UPPER][PADDED_BOARD_SPLINT_FULL_LEG].triggeringLocations, and remove the entries with ARM and HAND
  > Go to [FRACTURE_CLOSED_UPPER][PADDED_BOARD_SPLINT_FULL_ARM].triggeringLocations, and remove the entries with LEG and FOOT
  > Go to [FRACTURE_CLOSED_UPPER][PADDED_BOARD_SPLINT_WRAP_SHORT].triggeringLocations, and remove the entries with LEG and FOOT
  > Go to [FRACTURE_CLOSED_EXTREMITY][PADDED_BOARD_SPLINT_FULL_LEG].triggeringLocations, and remove the entries with ARM and HAND
  > Go to [FRACTURE_CLOSED_EXTREMITY][PADDED_BOARD_SPLINT_FULL_ARM].triggeringLocations, and remove the entries with LEG and FOOT
  > Go to [FRACTURE_CLOSED_EXTREMITY][PADDED_BOARD_SPLINT_WRAP_SHORT].triggeringLocations, and remove the entries with LEG and FOOT
*/